module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-7.2a746c2d.svg";